import PropTypes from "prop-types";
import { connect } from "react-redux";
import React, { Component } from "react";
import Button from "@mui/material/Button";
import MGridForm from "components/Shared/MGridForm";
import { DATA_TYPE_DATE } from "typeConstants/dataTypes";
import { getAppraisalFormData, setAppraisalFormData } from "actions/homeowner/caseforms";
import get1004pFormDefinition, { get1004pFormValidationGroups, getEnabledKvpForElectricalServiceRepeat } from "components/Homeowner/CaseForms/Appraisal1004P70H/V5/get1004pFormDefinition";
import moment from "moment-timezone";
import responseHandler from "responseHandler";
import { cloneDeep } from "lodash";
import ScrollToRequired from "components/FormElements/ScrollToRequired";
import PcrCommentaryDialog from "./PcrCommentaryDialog";
import { getAllPcrComments, setAllPcrComments } from "requests/pcrCommentary";

class Appraisal1004p70hV5 extends Component {
  constructor(props) {
    super(props);

    this.getFormData = this.getFormData.bind(this);
    this.getPcrData = this.getPcrData.bind(this);
    this.saveFormData = this.saveFormData.bind(this);

    this.on1004pChange = this.on1004pChange.bind(this);
    this.on1004pBlur = this.on1004pBlur.bind(this);
    this.getDateFields = this.getDateFields.bind(this);
    this.getRepeatIds = this.getRepeatIds.bind(this);

    this.mcardControlMethods = null;
    this.comparableCount = null;

    this.formControlMethods = null;

    this.get1004pFormDefinition = cloneDeep(get1004pFormDefinition);

    this.makeToast = this.makeToast.bind(this);
    this.getError = this.getError.bind(this);
    this.updateFormDefinitions = this.updateFormDefinitions.bind(this);
    this.getRepeatElementCount = this.getRepeatElementCount.bind(this);
    this.getRepeatElementFormDefinition = this.getRepeatElementFormDefinition.bind(this);
    this.insertRepeatElementsInFormDefinition = this.insertRepeatElementsInFormDefinition.bind(this);
    this.makeRepeatElements = this.makeRepeatElements.bind(this);
    this.getContainerDiv = this.getContainerDiv.bind(this);
    this.setElementIdInFocus = this.setElementIdInFocus.bind(this);

    this.getPcrCommentary = this.getPcrCommentary.bind(this);
    this.onUpdatePcrCommentary = this.onUpdatePcrCommentary.bind(this);
    this.onRemovePcrCommentary = this.onRemovePcrCommentary.bind(this);    
    this.addCommentaryMarkerToDefinition = this.addCommentaryMarkerToDefinition.bind(this);
    this.removeAllCommentaryMarkersFromDefinition = this.removeAllCommentaryMarkersFromDefinition.bind(this);
    this.onRevertPcrComment = this.onRevertPcrComment.bind(this);
    this.hidePcrDialog = this.hidePcrDialog.bind(this);
    this.shouldPromptForPcrCommentary = this.shouldPromptForPcrCommentary.bind(this);
    this.originalValueTransform = this.originalValueTransform.bind(this);

    this.getFieldDefinition = this.getFieldDefinition.bind(this);

    this.containerDiv = React.createRef();

    this.mounted = { current: true };

    this.state = {
      formData: null,
      pcrData: null,
      shouldRenderGridForm: true,
      scrollToRequiredFields: [],
      elementIdInFocus: null, 

      pcrDialogVisible: false,
      currentPcr: null,
      allPcrCommentary: [],
    };
  }

  componentDidMount() {
    this.props.getAppraisalFormData(this.props.controlNumber);            
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isFetchingAppraisalFormData && !this.props.isFetchingAppraisalFormData) {
      this.getPcrCommentary();      
      this.setState({ 
        formData: this.getFormData(this.props.dataForAppraisalForm), 
        pcrData: this.getPcrData(this.props.dataForAppraisalForm),         
      });
      this.updateFormDefinitions(this.props.dataForAppraisalForm);     
    }
  }

  getPcrCommentary() {
    getAllPcrComments(this.props.controlNumber, (pcr) => {
      if(pcr && pcr["pcrCommentary"]){
        this.setState({allPcrCommentary: [...pcr["pcrCommentary"]]});
      }
    }, this.mounted);     
  }

  getFieldDefinition() {
      this.removeAllCommentaryMarkersFromDefinition();
      this.state.allPcrCommentary.forEach(s => this.addCommentaryMarkerToDefinition(s.id)); 
      return this.get1004pFormDefinition;   
  }

  getDateFields() {
    return get1004pFormDefinition.flat().filter(f => f.dataType === DATA_TYPE_DATE).map(f => f.source);
  }

  // Key should be the repeat loop's export id
  getRepeatIds() {
    return {
      "comparables": ["FA-380", "FN-381", "FN-382", "FA-383"],
      "electrical-service": ["electrical-service-2", "off-grid-service", "solar-panel-ownership"]
    };
  }

  updateFormDefinitions(form) {
    if (!form) return null;
    let repeatElementExportId = "electrical-service";
    let repeatElementSource = "electrical-service-2";
    let repeatElementCount = this.getRepeatElementCount(repeatElementExportId, form); //int
    let repeatElementFormDefinition = this.getRepeatElementFormDefinition(repeatElementSource); //new []
    let repeatElementsToInsert = this.makeRepeatElements(repeatElementCount, getEnabledKvpForElectricalServiceRepeat, repeatElementFormDefinition); //new [[]]
    this.insertRepeatElementsInFormDefinition(repeatElementSource, repeatElementsToInsert);
  }

  getRepeatElementCount(repeatElementExportId, form) {
    let repeatElement = form.repeats.find(r => r.id === repeatElementExportId);
    return repeatElement ? repeatElement.groups.length : 0;
  }

  getRepeatElementFormDefinition(repeatElementSource) {
    return this.get1004pFormDefinition.find(r => r.some(e => e.source === repeatElementSource));
  }

  makeRepeatElements(repeatElementCount, enabledKvpFunc, repeatElementFormDefinition) {
    let repeatElementsToInsert = [];
    if (repeatElementCount === 0 || !repeatElementFormDefinition) return repeatElementsToInsert;
    for (let i = 1; i <= repeatElementCount; i++) {
      let newRepeatElementWithUpdatedSource = repeatElementFormDefinition.map(e => ({
        ...e,
        source: `${e.source}-${i}`,
        enabled: enabledKvpFunc(i)[`${e.source}-${i}`]
      }));
      repeatElementsToInsert.push(newRepeatElementWithUpdatedSource);
    }
    return repeatElementsToInsert;
  }

  insertRepeatElementsInFormDefinition(repeatElementSource, repeatElementsToInsert) {
    this.get1004pFormDefinition.splice(this.get1004pFormDefinition.findIndex(r => r.some(e => e.source === repeatElementSource)), 1, ...repeatElementsToInsert);
  }

  addCommentaryMarkerToDefinition(id){
    if(this.state.allPcrCommentary && this.state.allPcrCommentary.some(s => id === s.id)){
      let p = this.get1004pFormDefinition.find(t => t.find(p => p.source === id)).filter(q => q.source === id)[0];
      if(p) {
        let enabled = !(p.enabled) || (p.enabled && p.enabled(this.state.formData, id));
        if(enabled) {
          p.highlightField = true;
          p.onTooltipClicked = (fd) => {
            let curr = {...this.state.allPcrCommentary.filter(s => s.id === fd.source)};
            if(!curr[0]) curr = { id: fd.source };
            else curr = curr[0]; 
            curr.originalValue = this.state.pcrData[fd.source];
            this.setState({pcrDialogVisible: true, currentPcr: curr});          
          };
          p.toolTipText = "Edit PCR Comment";
        }
      }
    }
  }    

  removeAllCommentaryMarkersFromDefinition(){
    this.get1004pFormDefinition.forEach(s => s.forEach(p => {
      p.highlightField = false;
      p.onTooltipClicked = null;
    }));      
  }   

  getFormData(form) {
    if (!form) return null;

    let dates = this.getDateFields();

    //take YYYY-MM-DD pnx dates and make them MM-DD-YYYY
    let fixDate = d => {
      let split = d.split("-");
      return [split[1], split[2], split[0]].join("/");
    };

    let flattened = form.controls.reduce((acc, val) => {
      acc[val.id] = val.value;

      if (dates.indexOf(val.id) >= 0 && typeof val.value === "string" && val.value) {
        acc[val.id] = fixDate(val.value);
      }

      return acc;
    }, {});

    let repeats = form.repeats.filter(r => ["comparables", "electrical-service"].includes(r.id));
    let comparableGroups = repeats.find(r => r.id === "comparables").groups;

    this.comparableCount = comparableGroups.length;
    let repeatIds = this.getRepeatIds();
    let allRepeatIds = Object.keys(repeatIds).reduce((acc, cur) => acc = [...acc, ...repeatIds[cur]], []);
    repeats.forEach(r =>
      r.groups.forEach((g, i) =>
        g.controls.forEach(c => {
          if (allRepeatIds.find(id => id === c.id)) {
            let key = `${c.id}-${i + 1}`;
            let val = c.value;

            if (dates.indexOf(key) >= 0 && typeof val === "string") {
              val = fixDate(val);
            }

            flattened[key] = val;
          }
        })));

    flattened["comparable-count"] = this.comparableCount; //store this so we can use it in mgridform validation

    let controlHasData = (group, field) => {
      let control = group.controls.find(c => c.id === field);
      return !!(control && control.value.trim());
    };

    //mark comps enabled/disabled based on wether the comp grid has data for them
    comparableGroups.map(g => controlHasData(g, "FN-288") && controlHasData(g, "FN-289") && controlHasData(g, "FN-290") && controlHasData(g, "FN-291"))
      .forEach((enabled, i) => flattened[`comparable-enabled-${i + 1}`] = enabled);

    // If this case was a 1004 Hybrid / 70H converted to a 70H or 1004 Hybrid then additional date validation is needed
    if (this.props.caseHeader) {
      let { caseInfo } = this.props.caseHeader;
      if (caseInfo.originalInspectionType.code === "1004_HYBRID_70H_INSPECTION" 
        && (caseInfo.currentInspectionType.code === "FREDDIE_MAC_70H" || caseInfo.currentInspectionType.code === "FANNIE_MAE_1004_HYBRID")) {
        flattened["validate-report-dates"] = true;
      }
    }

    return flattened;
  }

  getPcrData(form) {
    if (!form) return null;

    let dates = this.getDateFields();

    //take YYYY-MM-DD pnx dates and make them MM-DD-YYYY
    let fixDate = d => {
      let split = d.split("-");
      return [split[1], split[2], split[0]].join("/");
    };

    let flattened = form.controls.reduce((acc, val) => {
      if(val.attributes && val.attributes.some(s => s.key === "originalValue")) {
        acc[val.id] = val.attributes.find(s => s.key === "originalValue").value;

        if (dates.indexOf(val.id) >= 0 && typeof val.attributes["originalValue"] === "string") {
          acc[val.id] = fixDate(val.attributes["originalValue"]);
        }
      }
      return acc;
    }, {});

    let repeats = form.repeats.filter(r => ["comparables", "electrical-service"].includes(r.id));
    let comparableGroups = repeats.find(r => r.id === "comparables").groups;

    this.comparableCount = comparableGroups.length;
    let repeatIds = this.getRepeatIds();
    let allRepeatIds = Object.keys(repeatIds).reduce((acc, cur) => acc = [...acc, ...repeatIds[cur]], []);
    repeats.forEach(r =>
      r.groups.forEach((g, i) =>
        g.controls.forEach(c => {
          if(c.attributes && c.attributes.some(s => s.key === "originalValue")) {
            if (allRepeatIds.find(id => id === c.id)) {
              let key = `${c.id}-${i + 1}`;
              let val = c.attributes.find(s => s.key === "originalValue").value;
  
              if (dates.indexOf(key) >= 0 && typeof val === "string") {
                val = fixDate(val);
              }
  
              flattened[key] = val;
            }            
          }
        })));

    return flattened;
  }  

  saveFormData() {
    let modifiedData = { controls: this.formControlMethods.getModifiedData() };

    let dates = this.getDateFields();
    let fixDate = d => moment(new Date(d)).format("YYYY-MM-DD");
    //change date format to something that phoenix understands
    modifiedData.controls.forEach(e => { if (dates.indexOf(e.id) >= 0 && typeof e.value === "string") e.value = fixDate(e.value); });

    //find the changed repeats that have ids that we care about
    //ex repeat id "FA-380" is represented 3-6 times in the form because the repeat has 3-6 controls, so it will be "FA-380-1", "FA-380-2", "FA-380-3", etc

    let repeatIds = this.getRepeatIds();
    Object.keys(repeatIds).forEach(k => {
      let changedRepeats = modifiedData.controls.map(c => c.id).filter(f => repeatIds[k].reduce((acc, id) => f.startsWith(id + "-") || acc, false));

      if (changedRepeats?.length) {
        //need to use .map instead of passing { controls: [] } into .fill because fill would just put the same reference in every time instead of constructing a new one
        let repeat = { id: k, groups: Array(this.getRepeatElementCount(k, this.props.dataForAppraisalForm)).fill().map(() => ({ controls: [] })) };

        modifiedData.repeats = modifiedData.repeats ? [...modifiedData.repeats, repeat] : [repeat];

        changedRepeats.forEach(r => {
          //changed repeats in the case of the 1004p form are FN-380 - FN-383 and then they have -# after denoting the repeat index (1 based) example FN-381-2 is index 1 on repeats(where id = "comparables").groups.controls
          let split = r.split("-");
          let index = parseInt(split.pop()) - 1;
          let source = split.join("-");

          let val = modifiedData.controls.find(e => e.id === r).value;

          //This is an exception. It is a field in Ext property form which accepts 1/0 for boolean.
          if (k === "electrical-service" && typeof val === "boolean") val = val ? "1" : "0";

          repeat.groups[index].controls.push({ id: source, value: val });
        });
      }
    });
    this.props.setAppraisalFormData(this.props.controlNumber, modifiedData, () => {
      if (this.props.onSave) this.props.onSave();
      if(this.state.allPcrCommentary) {
        let commentary = [...this.state.allPcrCommentary.filter(s => {
          let p = this.get1004pFormDefinition.find(t => t.find(p => p.source === s.id)).filter(q => q.source === s.id)[0];
          return !(p.enabled) || (p.enabled && p.enabled(this.state.formData, s.id));          
        })];
        setAllPcrComments(this.props.controlNumber, {"pcrCommentary": commentary}, null, this.mounted);
      }
      this.setState({ formData: null });      
      this.props.getAppraisalFormData(this.props.controlNumber);
    });
    if (!this.formControlMethods.isFormValid())
      this.makeToast("Save successful with failed validation.", "warning");
    else
      this.makeToast("Save successful. No validation errors.", "success");
  }

  // ------------------------------------------------------------------------------------------------
  // Toast and Error message helpers
  makeToast(text, type) { this.props.makeToast(text, type); }

  //simple method that will cause a controls error text to show if the variable passed in is not null or empty
  //pass true for meta if this is going to be used on an InputField because it is a custom control that handles errors different
  getError(message, meta) {
    if (message) {
      return meta
        ? { meta: { error: message, touched: true } }
        : { error: true, errorText: message };
    }
  }

  on1004pChange() {
    if (this.props.onChange) this.props.onChange();
  }

  shouldPromptForPcrCommentary(formDef, changedValue) {    
    if(!formDef.hasValidationError) return true;
    else {
      switch(changedValue) {
        case null:
        case undefined:
        case "":
          return false;
        case "false":
          if(formDef.dataType === "DATA_TYPE_CHECKBOX") return false;
          else return true;
        default:
          return true;
      }
    }
  }

  originalValueTransform(formDef, originalValue) {
    switch(formDef.dataType) {
      case "DATA_TYPE_CHECKBOX":
        switch(originalValue) {
          case null:
          case undefined:
          case "":
            return false;
          default:
            return originalValue;
        }
      default:
        return originalValue;
    }
  }

  on1004pBlur(fd, changedValue) {    
    if(fd.source in this.state.formData && fd.source in this.state.pcrData) {
      let formDef = this.get1004pFormDefinition.find(t => t.find(p => p.source === fd.source))
      .filter(q => q.source === fd.source)[0];        
      let originalValue = this.originalValueTransform(formDef, this.state.pcrData[fd.source]);

      if(originalValue !== changedValue) {
        if(this.state.formData[fd.source] !== changedValue){        
          if(this.shouldPromptForPcrCommentary(formDef, changedValue)){
            let curr = {id: fd.source, label: fd.label};
            if(this.state.allPcrCommentary){
              let found = {...this.state.allPcrCommentary.filter(s => s.id === fd.source)};
              if(found[0]) curr = found[0];
              else curr.new = true;
            }
            curr.originalValue = this.state.pcrData[fd.source];                      
            this.setState({pcrDialogVisible: true, currentPcr: curr}); 
          }
        }
      } else {
        this.onRemovePcrCommentary({id: fd.source, value: changedValue});
      }
    }
  }

  onUpdatePcrCommentary(pcr) {
    let currCommentary = [...this.state.allPcrCommentary];
    if(currCommentary.some(s => s.id === pcr.id)){
      currCommentary = currCommentary.map(s => s.id === pcr.id 
        ? {...s, reason: pcr.reason, commentary: pcr.commentary }
        : s);      
    } else {
      currCommentary.push(pcr);
    }

    let currFormData = {...this.state.formData};     
    let modified = this.formControlMethods.getModifiedData().filter(s => s.id === pcr.id)[0];
    if(modified){
      currFormData[pcr.id] = modified.value ?? "";    
    }      

    this.setState({allPcrCommentary: currCommentary, formData: currFormData});
    this.hidePcrDialog();
    this.props.onChange();
  }

  onRevertPcrComment(pcr) {    
    pcr.value = this.state.pcrData[pcr.id];    
    this.formControlMethods.setFieldModified(pcr.id, pcr.value);    
    


    this.onRemovePcrCommentary(pcr);  
    this.hidePcrDialog();      
  } 

  onRemovePcrCommentary(pcr) {   
    let currCommentary = [...this.state.allPcrCommentary];       
    currCommentary = currCommentary.filter(s => s.id !== pcr.id);   

    let currFormData = {...this.state.formData};          
    currFormData[pcr.id] = pcr.value; 
    
    this.setState({allPcrCommentary: currCommentary, formData: currFormData});   
    this.props.onChange();     
  }  



  hidePcrDialog() {
    this.setState({pcrDialogVisible: false, currentPcr: null});
  }

  getContainerDiv() {
    return this.containerDiv ?.current;
  }

  setElementIdInFocus(id) { this.setState({ elementIdInFocus: id }); }
  render() {
    return (
      this.state.shouldRenderGridForm &&
      <div className="appraisal-1004p-mgridform">
        <div className="appraisal-1004p-mgridform-header-row">
          {!this.props.readOnly &&
            <div className="appraisal-1004p-mgridform-save">
              <Button
                onClick={this.saveFormData}
              >
                Save
              </Button>
            </div>
          }
          {
            this.getContainerDiv() &&
            <ScrollToRequired fields={this.state.scrollToRequiredFields} containerDiv={this.getContainerDiv()} onChange={(prevId, curId) => {
              this.setState({ elementIdInFocus: curId });
            }} />
          }
        </div>
        <div className="appraisal-1004p-mgridform-form" ref={this.containerDiv}>
          <MGridForm
            width={1200}
            data={this.state.formData}
            onChange={this.on1004pChange}
            onBlur={this.on1004pBlur}
            formDefinition={this.state.formData && (this.props.readOnly ? this.get1004pFormDefinition.map(x => x.map(y => ({ ...y, enabled: () => false }))) : this.getFieldDefinition())}
            getControlMethods={cm => this.formControlMethods = cm}
            validationGroups={get1004pFormValidationGroups}
            onScrollToRequiredFieldsChange={o => this.setState({ scrollToRequiredFields: o })}
            setElementIdInFocus={this.setElementIdInFocus}
            elementIdInFocus={this.state.elementIdInFocus} />
        </div>
        {this.state.pcrDialogVisible && 
          <PcrCommentaryDialog 
            controlNumber={this.props.controlNumber}
            pcrDialogVisible={this.state.pcrDialogVisible} 
            currentPcr={this.state.currentPcr}
            updatePcrCommentary={this.onUpdatePcrCommentary}
            revertPcr={this.onRevertPcrComment}
            hidePcrDialog={this.hidePcrDialog} />}
      </div>
    );
  }
}

Appraisal1004p70hV5.propTypes = {
  controlNumber: PropTypes.number.isRequired,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  getAppraisalFormData: PropTypes.func.isRequired,
  setAppraisalFormData: PropTypes.func.isRequired,
  isFetchingAppraisalFormData: PropTypes.bool,
  isSavingAppraisalFormData: PropTypes.bool,
  dataForAppraisalForm: PropTypes.object,
  makeToast: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  caseHeader: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  isFetchingAppraisalFormData: state.caseForms.isFetchingAppraisalFormData,
  isSavingAppraisalFormData: state.caseForms.isSavingAppraisalFormData,
  dataForAppraisalForm: state.caseForms.dataForAppraisalForm,
  caseHeader: state.caseForms.caseHeader,
});

const mapDispatchToProps = (dispatch) => ({
  getAppraisalFormData(controlNumber) {
    dispatch(getAppraisalFormData(controlNumber));
  },
  setAppraisalFormData(controlNumber, modifiedData, callback) {
    dispatch(setAppraisalFormData(controlNumber, modifiedData, callback));
  },
  makeToast(text, type) {
    responseHandler.customToast(text, type, dispatch);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Appraisal1004p70hV5);
